import React from 'react';
import {Dialog, DialogBackdrop, DialogPanel} from "@headlessui/react";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";

const AlarmImageModal = ({open, onClose, src}) => {
    return (
        <Dialog open={open} onClose={onClose} className={"relative z-[9999]"}>
            <DialogBackdrop
                transition
                className={"fixed inset-0 bg-black opacity-50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"}
            />

            <div className={"fixed inset-0 flex w-screen items-center justify-center p-4"}>
                <DialogPanel className={"w-[75%] h-[90%] bg-transparent flex items-center justify-center"}>
                    <TransformWrapper>
                        <TransformComponent
                            wrapperStyle={{width: "100%", height: "100%"}}
                            contentStyle={{width: "100%", height: "100%"}}
                        >
                            <div style={{
                                background: `url("${src}") center center / contain no-repeat`,
                                height: "100%",
                                width: "100%"
                            }}/>
                        </TransformComponent>
                    </TransformWrapper>
                </DialogPanel>
            </div>
        </Dialog>
    );
};

export default AlarmImageModal;
